import { ITableConfig, ITableRowConfig } from 'components/Table/types';

const rowConfigs: ITableRowConfig[] = [
  { header: 'Article number', flexValue: 1, isLocked: true },
  { header: 'Description', flexValue: 2 },
  { header: 'Cutting length', flexValue: 1 },
  { header: 'Quantity', flexValue: 1 },
  { header: 'Unit', flexValue: 1 },
  { header: 'Routing link code', flexValue: 1 },
  { header: 'Not sell before NL', flexValue: 1 },
  { header: 'Not sell before RS', flexValue: 1 },
];

export const tableConfig: ITableConfig = {
  rowConfigs: rowConfigs,
};

// Key map for manage columns in table
export const columnKeyMap: Record<string, string> = {
  'Article number': 'id',
  Description: 'description',
  'Cutting length': 'length',
  Quantity: 'quantity_per',
  Unit: 'unit',
  'Routing link code': 'routing_link_code',
  'Not sell before NL': 'not_sell_before',
  'Not sell before RS': 'not_sell_after',
};
